// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get } from "@insite/client-framework/Services/ApiService";
import { IVMICategoryModel, IVMIFilteredBrandModel } from "@vanmeter/XDL/types";

const categoriesdropdownUrl = "/api/vmi/brands/categoriesdropdown";
const brandServiceUrl = "/api/vmi/brands/getbrandswithcategories";


export const getTopLevelCategories = async (): Promise<IVMICategoryModel[]> => {
    const result: IVMICategoryModel[] = await get<IVMICategoryModel[]>(categoriesdropdownUrl);
    return result;
};


export const getAllBrandsWithCategories = async (): Promise<IVMIFilteredBrandModel[]> => {
    const result: IVMIFilteredBrandModel[] = await get<IVMIFilteredBrandModel[]>(brandServiceUrl);
    return result;
};
